import { Card } from '../ui/Card';

const INSTALL_URL = 'https://slack.send-a-secret.link/install';

export default function SlackLanding() {
  return (
    <Card className="max-w-2xl">
      <h1 className="font-display text-3xl font-semibold tracking-tight text-text sm:text-[2rem]">
        Send-A-Secret for Slack
      </h1>
      <p className="mt-3 text-sm text-text-muted sm:text-base">
        Share credentials in Slack without leaving copies in channel history.
        Run <code className="rounded bg-bg px-1.5 py-0.5 font-mono text-[0.9em] text-text">/secret &lt;message&gt;</code>{' '}
        in any channel — the bot replies privately with a one-time link that auto-deletes after the first
        read or 10 minutes.
      </p>

      <div className="mt-7 flex justify-center">
        <a
          href={INSTALL_URL}
          aria-label="Add to Slack"
          className="inline-block rounded-md transition-transform duration-150 ease-out hover:scale-[1.02] focus:outline-none focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-primary"
        >
          <img
            alt="Add to Slack"
            height={40}
            width={139}
            src="https://platform.slack-edge.com/img/add_to_slack.png"
            srcSet="https://platform.slack-edge.com/img/add_to_slack.png 1x, https://platform.slack-edge.com/img/add_to_slack@2x.png 2x"
          />
        </a>
      </div>

      <h2 className="mt-10 font-display text-xl font-semibold text-text">How it works</h2>
      <ol className="mt-3 space-y-2 pl-5 text-sm text-text sm:text-base [&_li]:marker:text-primary [&_li]:marker:font-semibold" style={{ listStyleType: 'decimal' }}>
        <li>Type <code className="rounded bg-bg px-1.5 py-0.5 font-mono text-[0.9em]">/secret your message</code> in any channel.</li>
        <li>The bot replies only to you with a one-time link.</li>
        <li>Paste the link wherever you want to share it.</li>
        <li>The recipient opens it once. After that, the link is gone.</li>
      </ol>

      <h2 className="mt-10 font-display text-xl font-semibold text-text">What you get</h2>
      <ul className="mt-3 space-y-2 pl-5 text-sm text-text sm:text-base list-disc">
        <li>One-time links that self-destruct after first view or 10 minutes.</li>
        <li>Encrypted at rest — we never log the secret content.</li>
        <li>No accounts. No analytics. No tracking pixels.</li>
        <li>Workspace data deleted automatically when you uninstall.</li>
      </ul>

      <p className="mt-10 text-xs text-text-muted">
        Free. By Anavantis Technologies LLC. See{' '}
        <a href="/privacy" className="text-primary underline hover:text-primary-hover">privacy</a>,{' '}
        <a href="/terms" className="text-primary underline hover:text-primary-hover">terms</a>, and{' '}
        <a href="/support" className="text-primary underline hover:text-primary-hover">support</a>.
      </p>
    </Card>
  );
}
